import { render, staticRenderFns } from "./agreeToast.vue?vue&type=template&id=0ca89ee2&scoped=true&"
import script from "./agreeToast.vue?vue&type=script&lang=js&"
export * from "./agreeToast.vue?vue&type=script&lang=js&"
import style0 from "./agreeToast.vue?vue&type=style&index=0&id=0ca89ee2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca89ee2",
  null
  
)

export default component.exports